module.exports = __webpack_public_path__ + "static/media/garden_snake.237d35f8.png";